<template lang="html">
    <section class="aDemo">
        <vlt-modal :visible="!ready && !dismissed" class="Vlt-modal--large" message="Initializing..."
            title="Waiting for Initialization" :canCancel="false" @confirm="dismissed = true">
            <h3>Please wait while we initialize Call Verification</h3>
            <h4>This could take up to 30 seconds...</h4>
        </vlt-modal>
        <div class="Vlt-card">
            <h5>
                Google's Verified Calls currently require a special version of Google's Phone Dialer to be installed on
                your phone (v53+).<br>
                Without this Dialer, calls made through this demo will still work correctly, but they will not be
                Verified.
            </h5>
        </div>
        <div class="Vlt-grid">
            <div class="Vlt-col Vlt-col--A-1of3">
                <div>
                    <vlt-field>
                        <vue-phone-number-input color="#131415" :no-validator-state="false"
                            :default-country-code="nexmo.region" v-model="prettyNumber" @update="onUpdate" />
                    </vlt-field>
                    <vlt-button label="Check Number Registration" secondary app @click="doIt"
                        :disabled="(!isValid || !ready)" />
                </div>
                <vlt-field label="Answer Text">
                    <vlt-input textarea id="textmessage" :rows="4" v-model="message" placeholer="Sample"
                        :val="message" />
                </vlt-field>
                <vlt-button label="Make Validated Call" secondary app @click="call(true)"
                    :disabled="(!isValid || !ready)" />
                <vlt-button label="Make Unvalidated Call" secondary app @click="call(false)"
                    :disabled="(!isValid || !ready)" />
                <vlt-button v-if="false" label="Jump (Test)" secondary app @click="jump" />
                <br><br>
                <reportsAPI :nexmo="nexmo" reportType="VOICE-CALL" />
            </div>
            <div class="Vlt-col Vlt-col--A-2of3">
                <b>Delivery/Status messages</b>
                <div class="Vlt-table Vlt-table--short" data-sortable style="padding-bottom: 1px;">
                    <table>
                        <thead>
                            <tr>
                                <th>Time</th>
                                <th>Event</th>
                                <th>Status</th>
                                <th>Message</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in delivery">
                                <td>{{ item.time }}</td>
                                <td>{{ item.event }}</td>
                                <td>{{ item.result }}</td>
                                <td>{{ item.msg }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="js">
import axios from 'axios';
import {
    $HTTPDEMO,
    requestHandler
} from '../services/nidsService.js';
import {
    $NODEBASE
} from '../base';
import {
    $HTTP
} from "../services/nidsInternal.js";
import Pusher from "pusher-js";
import {
    parsePhoneNumberFromString
} from 'libphonenumber-js';
import {
    JSONView
} from "vue-json-component";
import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltGrid,
    VltCol,
    VltField,
    VltInput,
    VltModal,
} from "@vonagevolta/vue";
import reportsAPI from "@/components/reportsAPI";
export default {
    name: 'sampleDemo',
    data() {
        return {
            number: '',
            message: 'Thank you for using Vonage with Google Validated Calling',
            prettyNumber: '',
            numberStuff: {},
            fromNumber: '',
            isValid: true,
            DEMO: {},
            delivery: [],
            warned: false,
            instance: 'gverify',
            ready: true,
            dismissed: true,
            isLoading: false,
            demoItems: {},

        }
    },
    props: {
        nexmo: {
            type: Object,
            required: false
        }
    },
    methods: {
        async fetchDemos() {
            this.isLoading = true;
            console.log("Loading All Demos...");
            const {
                data
            } = await $HTTP.get("demos/all");
            this.demoItems = data;
            console.log(data);
            this.isLoading = false;
        },
        jump() {
            // TEST to propagate switching to a new demo up the chain.. it works!
            console.log("Jumping to: " + this.demoItems[2].component);
            this.$emit("launchDemo", this.demoItems[2]);
        },
        typeChange() {
            if (!this.warned) {
                this.$swal({
                    title: '<h4 style="color:red" >Warning</h4>',
                    showCloseButton: true,
                    html: '<h5>Standard and Advanced Insights are not available for all countries.  Please see the following page for more information regarding Insight Availability:</h5><br><h4><a style="color:green;text-decoration: underline" target="_blank" href="https://nexmoinc.atlassian.net/wiki/spaces/VER/pages/793477207/Number+Insight+Country+Support">Number Insight Country Support</a>  </h4>',
                    icon: 'info'
                });
            };
            this.warned = true;
        },
        doIt() {
            this.DEMO.post('check', {
                phone: this.number,
            }).then(request => {
                console.log("Check number reachability result for  " + this.number);
                console.log(request.data);
            });
        },
        call(valid) {
            this.DEMO.post('call', {
                phone: this.number,
                message: this.message,
                validate: valid
            }).then(request => {
                console.log("Call validation results for  " + this.number);
                console.log(request.data);
            });
        },
        register() {
            console.log("Registering the Demo Component with the associated backend");
            this.DEMO.post('register', {}).then(request => {
                console.log("Registration: ", request.data);
                if (request.data.token && request.data.token.length > 5) {
                    this.ready = true;
                } else {
                    this.ready = false;
                }
            });
            this.fetchDemos();
        },
        onUpdate(payload) {
            console.log(payload);
            this.numberStuff = payload;
            this.isValid = payload.isValid;
            if (payload.isValid) {
                this.number = this.numberStuff.formattedNumber.replace(/\D/g, '');;
            } else {
                var test = parsePhoneNumberFromString(payload.formattedNumber);
                console.log("Re-checked number: ", test)
                if (test.isValid()) {
                    this.isValid = true;
                    this.number = test.number.replace(/\D/g, '');
                    console.log("new this.number = ", this.number)
                } else {
                    this.isValid = false;
                }
            }
        },
        gotPush(data) {
            console.log("Got pusher data: ", data);
            var dtime = (new Date()).toISOString().split('.')[0].replace(/T|Z/g, " ");
            switch (data.event) {
                case 'token':
                    this.ready = false;
                    break;
                case 'register':
                    this.ready = true;
                case 'check':
                    this.delivery.unshift({
                        time: dtime,
                        event: data.event,
                        result: data.result,
                        msg: data.msg
                    });
                    if (data.event == 'check') {
                        if (data.msg.includes(' REACHABLE')) {
                            this.$swal('Success',
                                'Call Verification is available for ' + this.numberStuff.formatInternational,
                                'success');
                        } else {
                            this.$swal('Failure',
                                'Call Verification is NOT available for ' + this.numberStuff.formatInternational + ' (' + data.msg + ')',
                                'error');
                        }
                    }
                    break;
                default:
                    this.delivery.unshift({
                        time: dtime,
                        event: (data.event ? data.event : 'Unknown'),
                        result: (data.result ? data.result : 'Unknown'),
                        msg: (data.msg ? data.msg : 'Unknown')
                    });
            }
        },
    },
    components: {
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-input": VltInput,
        "vlt-modal": VltModal,
        "json-view": JSONView,
        reportsAPI,
    },
    beforeDestroy() {
        console.log("beforeDestroy for recognitionDemo")
        if (this.pusher) {
            this.pusher.unsubscribe(this.instance);
        }
    },
    created() {
        // If the backend is a NODE server, use this...
        var postscript = '/' + this.instance;
        if ($NODEBASE.indexOf('ngrok') > 0) {
            postscript = '';
        };
        var url = $NODEBASE + postscript;
        this.DEMO = axios.create({
            baseURL: url,
            headers: {
                'Content-Type': 'application/json'
            }
        })
        this.DEMO.interceptors.request.use(
            request => requestHandler(request)
        )
        console.log("Creating pusher subscription for key= " + this.nexmo['pusher_key']);
        let pusher = new Pusher(this.nexmo['pusher_key'], { //Pusher Key
            cluster: 'us3',
            forceTLS: true
        });
        this.pusher = pusher;
        this.channel = pusher.subscribe(this.instance);
        this.channel.bind("event_" + this.nexmo.userid, data => {
            this.gotPush(data);
        });
        this.register();
        this.fromNumber = parsePhoneNumberFromString("+" + this.nexmo['from']).formatInternational();
        this.prettyNumber = parsePhoneNumberFromString("+" + this.nexmo['phone']).formatNational();
        this.onUpdate({
            isValid: true,
            formatInternational: this.nexmo['phone'],
            formattedNumber: this.nexmo['phone'],
            countryCode: this.nexmo['region'],
        });
        console.log(this.nexmo);
    },
}
</script>

<style scoped lang="scss"></style>
